import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  IconButton,
  Slide,
} from '@mui/material';
import { ModalSuccessIconIcon } from '@app/icons';
import React, { PropsWithChildren } from 'react';
import { TransitionProps } from '@mui/material/transitions';

interface IProps {
  open: boolean;
  onClose: () => any;
  title?: string;
  content?: string;
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide ref={ref} direction="up" {...props} />;
});

const NotificationModal: React.FC<PropsWithChildren<IProps>> = ({
  open,
  onClose,
  title,
  content,
}) => {
  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: { p: 6, minWidth: '400px' },
      }}
      TransitionComponent={Transition}
      onClose={onClose}
    >
      <Box display="flex" justifyContent="flex-end">
        <IconButton sx={{ mr: '-8px', mt: '-8px' }} onClick={onClose}>
          <i className="ri-close-fill" style={{ fontSize: 24 }} />
        </IconButton>
      </Box>
      <Box display="flex" justifyContent="center" mb={3} mt={6}>
        <ModalSuccessIconIcon />
      </Box>
      {title && (
        <DialogTitle
          sx={{
            color: '#3E4144',
            textAlign: 'center',
            fontSize: '28px',
            fontWeight: 700,
            lineHeight: '34px',
            px: 6,
          }}
        >
          {title}
        </DialogTitle>
      )}
      <DialogContent>
        {content && (
          <DialogContentText
            align="center"
            sx={{
              mt: 2,
              fontWeight: '500',
              fontSize: '16px',
              lineHeight: '20px',
            }}
          >
            {content}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          justifyContent: 'center',
          p: 0,
          pt: 6,
        }}
      >
        <Button
          autoFocus
          size="large"
          sx={{
            display: 'flex',
            flexGrow: 1,
            maxWidth: '240px',
          }}
          variant="contained"
          onClick={onClose}
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NotificationModal;
